// src/fareCode.ts
import { summon } from "@silversea-ssc/functional-support";
import { fareKeys } from "@silversea-ssc/web-fares";
var FareCode = summon((F) => F.keysOf(fareKeys()));
export {
  FareCode
};
//# sourceMappingURL=index.js.map
